import { queryOptions } from '@tanstack/react-query'
import getServiceTemplates from '../api/get-service-templates'

export const getServiceTemplatesQueryKey = (citySlug: string, clientId?: string | null) =>
  ['service-templates', citySlug, clientId ?? null] as const

export const getServiceTemplateQueryOptions = (citySlug: string, clientId?: string | null) =>
  queryOptions({
    queryKey: getServiceTemplatesQueryKey(citySlug, clientId),
    queryFn: () => getServiceTemplates({ citySlug, clientId }),
  })
